import React from 'react';
import {Route, Redirect, IndexRedirect, IndexRoute} from 'react-router';

import {loadable} from 'lib/loadable/route';
import subjectRoutes from 'client/Dennis/V2/Subjects/routes';
import BatchRoutes from 'client/Dennis/BatchUtils/routes';

import GuideLevelPracticeView from './GuideLevelPracticeView/GuideLevelPracticeView.react';

const Dennis = loadable(() => import(/* webpackChunkName: "Dennis" */ './Dennis.react'));
/**
 * "Content" Components
 */
const Content = loadable(() => import('./Content/Content.react'));
const Queue = loadable(() => import('./Content/Queue/Queue.react'));
const SupplementManager = loadable(() =>
  import('client/Supplements/SupplementManager/SupplementManager.react')
);
const Standards = loadable(() => import('./StandardsV2/Standards.react'));
/**
 * "Users" Components
 */
const Users2 = loadable(() => import('./Users2/Users.react'));
const UserSearchWrapper = loadable(() => import('./UserEdit2/UserEditSearchWrapper.react'));
const UserForm = loadable(() => import('./UserEdit2/UserForm/UserForm.react'));
const UserWrapper = loadable(() => import('./UserEdit2/Wrapper/UserFormWrapper.react'));
const UserSubscriptions = loadable(() =>
  import('./UserEdit2/Subscriptions/UserSubscriptions.react')
);
const UserAuthoringPermissions = loadable(() =>
  import('./UserEdit2/Authoring/UserAuthoringPermissions.react')
);
/**
 * "Schools" Components
 */
const SchoolsLanding = loadable(() => import('./Schools/SchoolsLanding/SchoolsLanding.react'));
const SchoolsIndex = loadable(() => import('./Schools/SchoolsIndex/SchoolsIndex.react'));
const SchoolEdit = loadable(() => import('./Schools/SchoolsIndex/Edit/SchoolEdit.react'));
const SchoolCreate = loadable(() => import('./Schools/SchoolsIndex/Create/SchoolCreate.react'));
const SubjectGroupsIndex = loadable(() =>
  import('./Schools/SubjectGroups/SubjectGroupsIndex.react')
);
const SubjectGroupEdit = loadable(() =>
  import('./Schools/SubjectGroups/Edit/SubjectGroupEdit.react')
);
const SubjectGroupCreate = loadable(() =>
  import('./Schools/SubjectGroups/Create/SubjectGroupCreate.react')
);

const DistrictsList = loadable(() => import('./Districts/DistrictsList.react'));

const DennisRoutes = (
  <Route path='dennis' name='dennis' component={Dennis}>
    {BatchRoutes}
    <Route path='content' component={Content}>
      <Redirect from='question-set-search' to='queue' />
      <Redirect from='frq-queue' to='queue' />
      <IndexRedirect to='queue' />
      <Route
        path='queue(/:questionSetId)(/:questionId)'
        component={Queue}
        title='Queue | Albert.io'
      />
      {subjectRoutes}
      <Route path='supplements' component={SupplementManager} title='Supplements | Albert.io' />
      <Route path='standards' component={Standards} title='Standards | Dennis | Albert.io'>
        {/* @todo: Make this work */}
        <Route path=':subjectId' component={Standards} />
      </Route>
    </Route>
    <Route path='users' component={Users2}>
      <IndexRedirect to='search' />
      <Route path='search' component={UserSearchWrapper} />
      <Route path='edit/:userId' component={UserWrapper} title='User Edit | Dennis | Albert.io'>
        <IndexRoute component={UserForm} />
        <Route
          path='subscriptions'
          title='User Subscriptions Edit | Dennis | Albert.io'
          component={UserSubscriptions}
        />
        <Route
          path='authoring-permissions'
          title='User Authoring Permissions Edit | Dennis | Albert.io'
          component={UserAuthoringPermissions}
        />
      </Route>
      <Route path='create' component={UserWrapper} title='User Create | Dennis | Albert.io'>
        <IndexRoute component={UserForm} />
      </Route>
    </Route>
    <Route path='districts' component={DistrictsList} />
    <Route path='schools' component={SchoolsLanding}>
      <IndexRedirect to='school-list' />
      <Route path='school-list' component={SchoolsIndex} />
      <Route path='school-list/create' component={SchoolCreate} />
      <Route path='school-list/edit/:schoolId' component={SchoolEdit} />
      <Route path='subject-groups' component={SubjectGroupsIndex} />
      <Route path='subject-groups/create' component={SubjectGroupCreate} />
      <Route path='subject-groups/edit/:subjectGroupId' component={SubjectGroupEdit} />
    </Route>
    <Route path=':subjectSlug/:guideLevelSlug' component={GuideLevelPracticeView} />
  </Route>
);

export {DennisRoutes};
